// AUTOGENERATED
import * as $runtime from "../runtime.js";
import * as Data$dEnum$dGeneric from "../Data.Enum.Generic/index.js";
import * as Data$dEq from "../Data.Eq/index.js";
import * as Data$dFunctor from "../Data.Functor/index.js";
import * as Data$dGeneric$dRep from "../Data.Generic.Rep/index.js";
import * as Data$dInt from "../Data.Int/index.js";
import * as Data$dList$dTypes from "../Data.List.Types/index.js";
import * as Data$dMap$dInternal from "../Data.Map.Internal/index.js";
import * as Data$dMap$dOrdered from "../Data.Map.Ordered/index.js";
import * as Data$dMap$dSerialized from "../Data.Map.Serialized/index.js";
import * as Data$dMaybe from "../Data.Maybe/index.js";
import * as Data$dMoney$dRounded from "../Data.Money.Rounded/index.js";
import * as Data$dOrd from "../Data.Ord/index.js";
import * as Data$dOrdering from "../Data.Ordering/index.js";
import * as Data$dShow from "../Data.Show/index.js";
import * as Data$dShow$dGeneric from "../Data.Show.Generic/index.js";
import * as Data$dTuple from "../Data.Tuple/index.js";
import * as Data$dTuple$dT2 from "../Data.Tuple.T2/index.js";
import * as Data$dUUID from "../Data.UUID/index.js";
import * as Foreign$dEncoding from "../Foreign.Encoding/index.js";
import * as Foreign$dGeneric$dClass from "../Foreign.Generic.Class/index.js";
import * as Foreign$dGeneric$dEnumEncoding from "../Foreign.Generic.EnumEncoding/index.js";
import * as Foreign$dNullOrUndefined from "../Foreign.NullOrUndefined/index.js";
import * as Restaumatic$dI18n$dTypes from "../Restaumatic.I18n.Types/index.js";
import * as Restaumatic$dLocales from "../Restaumatic.Locales/index.js";
import * as Restaumatic$dMenu$dV2$dTypes$dAllergen from "../Restaumatic.Menu.V2.Types.Allergen/index.js";
import * as Restaumatic$dMenu$dV2$dTypes$dAvailability from "../Restaumatic.Menu.V2.Types.Availability/index.js";
import * as Restaumatic$dMenu$dV2$dTypes$dPackagingContainer from "../Restaumatic.Menu.V2.Types.PackagingContainer/index.js";
import * as Restaumatic$dMenu$dV2$dTypes$dParametric$dParametric from "../Restaumatic.Menu.V2.Types.Parametric.Parametric/index.js";
import * as Restaumatic$dMenu$dV2$dTypes$dPhoto from "../Restaumatic.Menu.V2.Types.Photo/index.js";
import * as Restaumatic$dMenu$dV2$dTypes$dVatRate from "../Restaumatic.Menu.V2.Types.VatRate/index.js";
import * as Type$dProxy from "../Type.Proxy/index.js";
import * as Unsafe$dCoerce from "../Unsafe.Coerce/index.js";
import * as Unscramble from "../Unscramble/index.js";
import * as Unscramble$dEnum from "../Unscramble.Enum/index.js";
import * as Unscramble$dGeneric from "../Unscramble.Generic/index.js";
const $DefaultModifierItemsExchangePolicy = tag => ({tag});
const $ModifierDisplayMode = tag => ({tag});
const $ModifierVatRate = (tag, _1) => ({tag, _1});
const eq1 = /* #__PURE__ */ (() => Data$dMap$dInternal.eqMap(Restaumatic$dMenu$dV2$dTypes$dAllergen.eqAllergen)(Restaumatic$dMenu$dV2$dTypes$dAllergen.eqAllergenConcentration).eq)();
const eq3 = /* #__PURE__ */ (() => Restaumatic$dMenu$dV2$dTypes$dParametric$dParametric.eqParametric(Data$dEq.eqBoolean).eq)();
const eqTranslated = /* #__PURE__ */ Data$dMap$dInternal.eqMap(Restaumatic$dLocales.eqLocale)(Data$dEq.eqString);
const eq7 = x => y => {
  if (x.tag === "Nothing") { return y.tag === "Nothing"; }
  if (x.tag === "Just") {
    if (y.tag === "Just") { return Restaumatic$dMenu$dV2$dTypes$dPackagingContainer.eqPackagingContainersConf.eq(x._1)(y._1); }
    return false;
  }
  return false;
};
const eq9 = /* #__PURE__ */ (() => Restaumatic$dMenu$dV2$dTypes$dParametric$dParametric.eqParametric(Data$dEq.eqInt).eq)();
const eq10 = x => y => {
  if (x.tag === "Nothing") { return y.tag === "Nothing"; }
  if (x.tag === "Just") {
    if (y.tag === "Just") { return eqTranslated.eq(x._1)(y._1); }
    return false;
  }
  return false;
};
const eq12 = /* #__PURE__ */ Data$dEq.eqArrayImpl(Data$dEq.eqStringImpl);
const IncludedInProductIsSymbol = {reflectSymbol: () => "IncludedInProduct"};
const SeparateIsSymbol = {reflectSymbol: () => "Separate"};
const allergensIsSymbol = {reflectSymbol: () => "allergens"};
const availabilityIsSymbol = {reflectSymbol: () => "availability"};
const availableWhenIsSymbol = {reflectSymbol: () => "availableWhen"};
const defaultSelectionIsSymbol = {reflectSymbol: () => "defaultSelection"};
const irremovableIsSymbol = {reflectSymbol: () => "irremovable"};
const nameIsSymbol = {reflectSymbol: () => "name"};
const packagingContainersConfigIsSymbol = {reflectSymbol: () => "packagingContainersConfig"};
const photoIsSymbol = {reflectSymbol: () => "photo"};
const priceIsSymbol = {reflectSymbol: () => "price"};
const showMaybe = {
  show: v => {
    if (v.tag === "Just") { return "(Just " + Restaumatic$dMenu$dV2$dTypes$dPhoto.showPhoto.show(v._1) + ")"; }
    if (v.tag === "Nothing") { return "Nothing"; }
    $runtime.fail();
  }
};
const showTranslated = /* #__PURE__ */ Data$dMap$dInternal.showMap(Restaumatic$dLocales.showLocale)(Data$dShow.showString);
const showParametric = /* #__PURE__ */ Restaumatic$dMenu$dV2$dTypes$dParametric$dParametric.showParametric(Data$dShow.showBoolean);
const ModifierItemIsSymbol = {reflectSymbol: () => "ModifierItem"};
const itemsIsSymbol = {reflectSymbol: () => "items"};
const showMaybe1 = {
  show: v => {
    if (v.tag === "Just") { return "(Just " + showTranslated.show(v._1) + ")"; }
    if (v.tag === "Nothing") { return "Nothing"; }
    $runtime.fail();
  }
};
const ModifierItemSectionIsSymbol = {reflectSymbol: () => "ModifierItemSection"};
const udecodeParametric = /* #__PURE__ */ Restaumatic$dMenu$dV2$dTypes$dParametric$dParametric.udecodeParametric(Unscramble.decodeBoolean1);
const decodeRecordCons = /* #__PURE__ */ Unscramble.decodeRecordCons(availableWhenIsSymbol)(udecodeParametric);
const udecodeTranslated = /* #__PURE__ */ Restaumatic$dI18n$dTypes.decodeMap(Unscramble.decodeString1);
const decodeRecordCons2 = /* #__PURE__ */ Unscramble.decodeRecordCons(nameIsSymbol)(udecodeTranslated);
const decodeRecordCons3 = /* #__PURE__ */ Unscramble.decodeRecordCons(photoIsSymbol)(/* #__PURE__ */ Unscramble.decodeMaybe(Restaumatic$dMenu$dV2$dTypes$dPhoto.unscrambleDecodePhoto));
const decodeMaybe = /* #__PURE__ */ Unscramble.decodeMaybe(udecodeTranslated);
const ModifierListIsSymbol = {reflectSymbol: () => "ModifierList"};
const ModifierCheckboxListIsSymbol = {reflectSymbol: () => "ModifierCheckboxList"};
const ModifierRadioButtonListIsSymbol = {reflectSymbol: () => "ModifierRadioButtonList"};
const ModifierPizzaGridIsSymbol = {reflectSymbol: () => "ModifierPizzaGrid"};
const ModifierHiddenIsSymbol = {reflectSymbol: () => "ModifierHidden"};
const genericTopConstructor = {"genericTop'": Data$dGeneric$dRep.NoArguments};
const genericBottomConstructor = {"genericBottom'": Data$dGeneric$dRep.NoArguments};
const genericBottomSum = {"genericBottom'": /* #__PURE__ */ Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments)};
const genericEnumConstructor = /* #__PURE__ */ Data$dEnum$dGeneric.genericEnumConstructor(Data$dEnum$dGeneric.genericEnumNoArguments);
const genericEnumSum = /* #__PURE__ */ Data$dEnum$dGeneric.genericEnumSum(genericEnumConstructor)(genericTopConstructor);
const genericEnumSum1 = /* #__PURE__ */ genericEnumSum(/* #__PURE__ */ genericEnumSum(/* #__PURE__ */ genericEnumSum(genericEnumConstructor)(genericBottomConstructor))(genericBottomSum))(genericBottomSum);
const genericEnumSum2 = /* #__PURE__ */ genericEnumSum(genericEnumSum1)(genericBottomSum);
const genericBoundedEnumConstructor = /* #__PURE__ */ Data$dEnum$dGeneric.genericBoundedEnumConstructor(Data$dEnum$dGeneric.genericBoundedEnumNoArguments);
const genericBoundedEnumSum = /* #__PURE__ */ Data$dEnum$dGeneric.genericBoundedEnumSum(genericBoundedEnumConstructor);
const genericBoundedEnumSum1 = /* #__PURE__ */ genericBoundedEnumSum(/* #__PURE__ */ genericBoundedEnumSum(/* #__PURE__ */ genericBoundedEnumSum(genericBoundedEnumConstructor)));
const genericBoundedEnumSum2 = /* #__PURE__ */ genericBoundedEnumSum(genericBoundedEnumSum1);
const NotIncludedIsSymbol = {reflectSymbol: () => "NotIncluded"};
const UnlimitedExchangeIsSymbol = {reflectSymbol: () => "UnlimitedExchange"};
const ExchangeWithClampIsSymbol = {reflectSymbol: () => "ExchangeWithClamp"};
const AdditionOnlyIsSymbol = {reflectSymbol: () => "AdditionOnly"};
const adminNoteIsSymbol = {reflectSymbol: () => "adminNote"};
const defaultPriceParametersIsSymbol = {reflectSymbol: () => "defaultPriceParameters"};
const descriptionIsSymbol = {reflectSymbol: () => "description"};
const displayModeIsSymbol = {reflectSymbol: () => "displayMode"};
const divisibleIsSymbol = {reflectSymbol: () => "divisible"};
const exchangePolicyIsSymbol = {reflectSymbol: () => "exchangePolicy"};
const maxDuplicatesPerItemIsSymbol = {reflectSymbol: () => "maxDuplicatesPerItem"};
const maxItemsIsSymbol = {reflectSymbol: () => "maxItems"};
const minItemsIsSymbol = {reflectSymbol: () => "minItems"};
const modifierVatRateIsSymbol = {reflectSymbol: () => "modifierVatRate"};
const sectionsIsSymbol = {reflectSymbol: () => "sections"};
const userEditableWhenIsSymbol = {reflectSymbol: () => "userEditableWhen"};
const userInputRequiredWhenIsSymbol = {reflectSymbol: () => "userInputRequiredWhen"};
const showMaybe2 = {
  show: v => {
    if (v.tag === "Just") { return "(Just " + Data$dShow.showIntImpl(v._1) + ")"; }
    if (v.tag === "Nothing") { return "Nothing"; }
    $runtime.fail();
  }
};
const ModifierIsSymbol = {reflectSymbol: () => "Modifier"};
const decodeMaybe1 = /* #__PURE__ */ Unscramble.decodeMaybe(Unscramble.decodeInt1);
const encodeWithOptionsOther = {
  encodeWithOptions: v => v2 => {
    if (v2.tag === "Nothing") { return Foreign$dNullOrUndefined.nullImpl; }
    if (v2.tag === "Just") {
      return Foreign$dGeneric$dClass.genericEncodeConstructor(Restaumatic$dMenu$dV2$dTypes$dPhoto.PhotoIsSymbol)({
        encodeArgs: opts => v$1 => Data$dList$dTypes.$List("Cons", Foreign$dGeneric$dClass.$Arg("PlainArg", v$1), Data$dList$dTypes.Nil)
      }).encodeOpts(Foreign$dEncoding.options)(v2._1);
    }
    $runtime.fail();
  }
};
const encodeTranslated = /* #__PURE__ */ Restaumatic$dI18n$dTypes.encodeTranslated(Foreign$dGeneric$dClass.stringEncode);
const encodeWithOptionsOther1 = {encodeWithOptions: v => encodeTranslated.encode};
const encodeWithOptionsOther2 = {encodeWithOptions: v => Unsafe$dCoerce.unsafeCoerce};
const encodeWithOptionsOther3 = {encodeWithOptions: v => Unsafe$dCoerce.unsafeCoerce};
const encodeWithOptionsOther4 = /* #__PURE__ */ (() => {
  const encode1 = Restaumatic$dMenu$dV2$dTypes$dParametric$dParametric.encodeParametric(Foreign$dGeneric$dClass.booleanEncode)({
    encodeArgs: opts => v => Data$dList$dTypes.$List("Cons", Foreign$dGeneric$dClass.$Arg("PlainArg", v), Data$dList$dTypes.Nil)
  }).encode;
  return {encodeWithOptions: v => encode1};
})();
const encodeWithOptionsOther5 = {
  encodeWithOptions: v => v2 => {
    if (v2.tag === "Nothing") { return Foreign$dNullOrUndefined.nullImpl; }
    if (v2.tag === "Just") { return encodeTranslated.encode(v2._1); }
    $runtime.fail();
  }
};
const encodeWithOptionsOther6 = {
  encodeWithOptions: v => v2 => {
    if (v2.tag === "Nothing") { return Foreign$dNullOrUndefined.nullImpl; }
    if (v2.tag === "Just") { return v2._1; }
    $runtime.fail();
  }
};
const decodeWithOptionsOther = {decodeWithOptions: v => Foreign$dNullOrUndefined.readNullOrUndefined(Restaumatic$dMenu$dV2$dTypes$dPhoto.decodePhoto.decode)};
const decodeTranslated = /* #__PURE__ */ Restaumatic$dI18n$dTypes.decodeTranslated(Foreign$dGeneric$dClass.stringDecode);
const decodeWithOptionsOther1 = {decodeWithOptions: v => decodeTranslated.decode};
const decodeWithOptionsOther2 = {decodeWithOptions: v => Foreign$dGeneric$dClass.booleanDecode.decode};
const decodeWithOptionsOther3 = {decodeWithOptions: v => Foreign$dGeneric$dClass.intDecode.decode};
const decodeWithOptionsOther4 = /* #__PURE__ */ (() => {
  const decode2 = Restaumatic$dMenu$dV2$dTypes$dParametric$dParametric.decodeParametric(Foreign$dGeneric$dClass.booleanDecode)({
    decodeArgs: Foreign$dGeneric$dClass.decodeArgsArgument(decodeWithOptionsOther2),
    decodeSingleRecordArg: Data$dMaybe.Nothing
  }).decode;
  return {decodeWithOptions: v => decode2};
})();
const decodeWithOptionsOther5 = {decodeWithOptions: v => Foreign$dNullOrUndefined.readNullOrUndefined(decodeTranslated.decode)};
const decodeWithOptionsOther6 = {decodeWithOptions: v => Foreign$dNullOrUndefined.readNullOrUndefined(Foreign$dGeneric$dClass.intDecode.decode)};
const IncludedInProduct = /* #__PURE__ */ $ModifierVatRate("IncludedInProduct");
const Separate = value0 => $ModifierVatRate("Separate", value0);
const ModifierItem = x => x;
const ModifierItemSection = x => x;
const ModifierList = /* #__PURE__ */ $ModifierDisplayMode("ModifierList");
const ModifierCheckboxList = /* #__PURE__ */ $ModifierDisplayMode("ModifierCheckboxList");
const ModifierRadioButtonList = /* #__PURE__ */ $ModifierDisplayMode("ModifierRadioButtonList");
const ModifierPizzaGrid = /* #__PURE__ */ $ModifierDisplayMode("ModifierPizzaGrid");
const ModifierHidden = /* #__PURE__ */ $ModifierDisplayMode("ModifierHidden");
const NotIncluded = /* #__PURE__ */ $DefaultModifierItemsExchangePolicy("NotIncluded");
const UnlimitedExchange = /* #__PURE__ */ $DefaultModifierItemsExchangePolicy("UnlimitedExchange");
const ExchangeWithClamp = /* #__PURE__ */ $DefaultModifierItemsExchangePolicy("ExchangeWithClamp");
const AdditionOnly = /* #__PURE__ */ $DefaultModifierItemsExchangePolicy("AdditionOnly");
const Modifier = x => x;
const newtypeModifier_ = {Coercible0: () => {}};
const newtypeModifierItem_ = {Coercible0: () => {}};
const newtypeModifierItemSectio = {Coercible0: () => {}};
const hasFieldModifierItemSecti = dictHasField => dictHasField;
const hasFieldModifierItem = dictHasField => dictHasField;
const hasFieldModifier = dictHasField => dictHasField;
const eqModifierVatRate = {
  eq: x => y => {
    if (x.tag === "IncludedInProduct") { return y.tag === "IncludedInProduct"; }
    if (x.tag === "Separate") {
      if (y.tag === "Separate") {
        if (x._1.tag === "VatA") { return y._1.tag === "VatA"; }
        if (x._1.tag === "VatB") { return y._1.tag === "VatB"; }
        if (x._1.tag === "VatC") { return y._1.tag === "VatC"; }
        if (x._1.tag === "VatD") { return y._1.tag === "VatD"; }
        if (x._1.tag === "VatE") { return y._1.tag === "VatE"; }
        if (x._1.tag === "VatF") { return y._1.tag === "VatF"; }
        if (x._1.tag === "VatG") { return y._1.tag === "VatG"; }
        return false;
      }
      return false;
    }
    return false;
  }
};
const ordModifierVatRate = {
  compare: x => y => {
    if (x.tag === "IncludedInProduct") {
      if (y.tag === "IncludedInProduct") { return Data$dOrdering.EQ; }
      return Data$dOrdering.LT;
    }
    if (y.tag === "IncludedInProduct") { return Data$dOrdering.GT; }
    if (x.tag === "Separate") {
      if (y.tag === "Separate") { return Restaumatic$dMenu$dV2$dTypes$dVatRate.ordVatRate.compare(x._1)(y._1); }
      $runtime.fail();
    }
    $runtime.fail();
  },
  Eq0: () => eqModifierVatRate
};
const eqModifierItem = {
  eq: x => y => eq1(x.allergens)(y.allergens) && (() => {
    if (x.availability.tag === "Available") { return y.availability.tag === "Available"; }
    if (x.availability.tag === "TemporarilyUnavailable") { return y.availability.tag === "TemporarilyUnavailable"; }
    if (x.availability.tag === "Hidden") { return y.availability.tag === "Hidden"; }
    return false;
  })() && eq3(x.availableWhen)(y.availableWhen) && x.defaultSelection === y.defaultSelection && x.irremovable === y.irremovable && eqTranslated.eq(x.name)(y.name) && eq7(x.packagingContainersConfig)(y.packagingContainersConfig) && (() => {
    if (x.photo.tag === "Nothing") { return y.photo.tag === "Nothing"; }
    if (x.photo.tag === "Just") {
      if (y.photo.tag === "Just") { return x.photo._1 === y.photo._1; }
      return false;
    }
    return false;
  })() && eq9(x.price)(y.price)
};
const eq15 = /* #__PURE__ */ (() => Data$dMap$dOrdered.eqOMap(Data$dEq.eqString)(eqModifierItem).eq)();
const eqModifierItemSection = {
  eq: x => y => eq15(x.items)(y.items) && eq10(x.name)(y.name) && (() => {
    if (x.photo.tag === "Nothing") { return y.photo.tag === "Nothing"; }
    if (x.photo.tag === "Just") {
      if (y.photo.tag === "Just") { return x.photo._1 === y.photo._1; }
      return false;
    }
    return false;
  })()
};
const eq16 = /* #__PURE__ */ (() => Data$dEq.eqArrayImpl(eqModifierItemSection.eq))();
const eqModifierDisplayMode = {
  eq: x => y => {
    if (x.tag === "ModifierList") { return y.tag === "ModifierList"; }
    if (x.tag === "ModifierCheckboxList") { return y.tag === "ModifierCheckboxList"; }
    if (x.tag === "ModifierRadioButtonList") { return y.tag === "ModifierRadioButtonList"; }
    if (x.tag === "ModifierPizzaGrid") { return y.tag === "ModifierPizzaGrid"; }
    if (x.tag === "ModifierHidden") { return y.tag === "ModifierHidden"; }
    return false;
  }
};
const ordModifierDisplayMode = {
  compare: x => y => {
    if (x.tag === "ModifierList") {
      if (y.tag === "ModifierList") { return Data$dOrdering.EQ; }
      return Data$dOrdering.LT;
    }
    if (y.tag === "ModifierList") { return Data$dOrdering.GT; }
    if (x.tag === "ModifierCheckboxList") {
      if (y.tag === "ModifierCheckboxList") { return Data$dOrdering.EQ; }
      return Data$dOrdering.LT;
    }
    if (y.tag === "ModifierCheckboxList") { return Data$dOrdering.GT; }
    if (x.tag === "ModifierRadioButtonList") {
      if (y.tag === "ModifierRadioButtonList") { return Data$dOrdering.EQ; }
      return Data$dOrdering.LT;
    }
    if (y.tag === "ModifierRadioButtonList") { return Data$dOrdering.GT; }
    if (x.tag === "ModifierPizzaGrid") {
      if (y.tag === "ModifierPizzaGrid") { return Data$dOrdering.EQ; }
      return Data$dOrdering.LT;
    }
    if (y.tag === "ModifierPizzaGrid") { return Data$dOrdering.GT; }
    if (x.tag === "ModifierHidden") {
      if (y.tag === "ModifierHidden") { return Data$dOrdering.EQ; }
      $runtime.fail();
    }
    $runtime.fail();
  },
  Eq0: () => eqModifierDisplayMode
};
const eqDefaultModifierItemsExc = {
  eq: x => y => {
    if (x.tag === "NotIncluded") { return y.tag === "NotIncluded"; }
    if (x.tag === "UnlimitedExchange") { return y.tag === "UnlimitedExchange"; }
    if (x.tag === "ExchangeWithClamp") { return y.tag === "ExchangeWithClamp"; }
    if (x.tag === "AdditionOnly") { return y.tag === "AdditionOnly"; }
    return false;
  }
};
const eqModifier = {
  eq: x => y => x.adminNote === y.adminNote && eq3(x.availableWhen)(y.availableWhen) && eq12(x.defaultPriceParameters)(y.defaultPriceParameters) && eq10(x.description)(y.description) && (() => {
    if (x.displayMode.tag === "ModifierList") { return y.displayMode.tag === "ModifierList"; }
    if (x.displayMode.tag === "ModifierCheckboxList") { return y.displayMode.tag === "ModifierCheckboxList"; }
    if (x.displayMode.tag === "ModifierRadioButtonList") { return y.displayMode.tag === "ModifierRadioButtonList"; }
    if (x.displayMode.tag === "ModifierPizzaGrid") { return y.displayMode.tag === "ModifierPizzaGrid"; }
    if (x.displayMode.tag === "ModifierHidden") { return y.displayMode.tag === "ModifierHidden"; }
    return false;
  })() && x.divisible === y.divisible && (() => {
    if (x.exchangePolicy.tag === "NotIncluded") { return y.exchangePolicy.tag === "NotIncluded"; }
    if (x.exchangePolicy.tag === "UnlimitedExchange") { return y.exchangePolicy.tag === "UnlimitedExchange"; }
    if (x.exchangePolicy.tag === "ExchangeWithClamp") { return y.exchangePolicy.tag === "ExchangeWithClamp"; }
    if (x.exchangePolicy.tag === "AdditionOnly") { return y.exchangePolicy.tag === "AdditionOnly"; }
    return false;
  })() && (() => {
    if (x.maxDuplicatesPerItem.tag === "Nothing") { return y.maxDuplicatesPerItem.tag === "Nothing"; }
    if (x.maxDuplicatesPerItem.tag === "Just") {
      if (y.maxDuplicatesPerItem.tag === "Just") { return x.maxDuplicatesPerItem._1 === y.maxDuplicatesPerItem._1; }
      return false;
    }
    return false;
  })() && (() => {
    if (x.maxItems.tag === "Nothing") { return y.maxItems.tag === "Nothing"; }
    if (x.maxItems.tag === "Just") {
      if (y.maxItems.tag === "Just") { return x.maxItems._1 === y.maxItems._1; }
      return false;
    }
    return false;
  })() && x.minItems === y.minItems && (() => {
    if (x.modifierVatRate.tag === "IncludedInProduct") { return y.modifierVatRate.tag === "IncludedInProduct"; }
    if (x.modifierVatRate.tag === "Separate") {
      if (y.modifierVatRate.tag === "Separate") {
        if (x.modifierVatRate._1.tag === "VatA") { return y.modifierVatRate._1.tag === "VatA"; }
        if (x.modifierVatRate._1.tag === "VatB") { return y.modifierVatRate._1.tag === "VatB"; }
        if (x.modifierVatRate._1.tag === "VatC") { return y.modifierVatRate._1.tag === "VatC"; }
        if (x.modifierVatRate._1.tag === "VatD") { return y.modifierVatRate._1.tag === "VatD"; }
        if (x.modifierVatRate._1.tag === "VatE") { return y.modifierVatRate._1.tag === "VatE"; }
        if (x.modifierVatRate._1.tag === "VatF") { return y.modifierVatRate._1.tag === "VatF"; }
        if (x.modifierVatRate._1.tag === "VatG") { return y.modifierVatRate._1.tag === "VatG"; }
        return false;
      }
      return false;
    }
    return false;
  })() && eqTranslated.eq(x.name)(y.name) && (() => {
    if (x.photo.tag === "Nothing") { return y.photo.tag === "Nothing"; }
    if (x.photo.tag === "Just") {
      if (y.photo.tag === "Just") { return x.photo._1 === y.photo._1; }
      return false;
    }
    return false;
  })() && eq16(x.sections)(y.sections) && eq3(x.userEditableWhen)(y.userEditableWhen) && eq3(x.userInputRequiredWhen)(y.userInputRequiredWhen)
};
const ordDefaultModifierItemsEx = {
  compare: x => y => {
    if (x.tag === "NotIncluded") {
      if (y.tag === "NotIncluded") { return Data$dOrdering.EQ; }
      return Data$dOrdering.LT;
    }
    if (y.tag === "NotIncluded") { return Data$dOrdering.GT; }
    if (x.tag === "UnlimitedExchange") {
      if (y.tag === "UnlimitedExchange") { return Data$dOrdering.EQ; }
      return Data$dOrdering.LT;
    }
    if (y.tag === "UnlimitedExchange") { return Data$dOrdering.GT; }
    if (x.tag === "ExchangeWithClamp") {
      if (y.tag === "ExchangeWithClamp") { return Data$dOrdering.EQ; }
      return Data$dOrdering.LT;
    }
    if (y.tag === "ExchangeWithClamp") { return Data$dOrdering.GT; }
    if (x.tag === "AdditionOnly") {
      if (y.tag === "AdditionOnly") { return Data$dOrdering.EQ; }
      $runtime.fail();
    }
    $runtime.fail();
  },
  Eq0: () => eqDefaultModifierItemsExc
};
const genericModifierVatRate = {
  to: x => {
    if (x.tag === "Inl") { return IncludedInProduct; }
    if (x.tag === "Inr") { return $ModifierVatRate("Separate", x._1); }
    $runtime.fail();
  },
  from: x => {
    if (x.tag === "IncludedInProduct") { return Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments); }
    if (x.tag === "Separate") { return Data$dGeneric$dRep.$Sum("Inr", x._1); }
    $runtime.fail();
  }
};
const showModifierVatRate = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)(IncludedInProductIsSymbol);
    const $1 = Data$dShow$dGeneric.genericShowConstructor({genericShowArgs: v => [Restaumatic$dMenu$dV2$dTypes$dVatRate.showVatRate.show(v)]})(SeparateIsSymbol);
    return x => {
      if (x.tag === "IncludedInProduct") { return $0["genericShow'"](Data$dGeneric$dRep.NoArguments); }
      if (x.tag === "Separate") { return $1["genericShow'"](x._1); }
      $runtime.fail();
    };
  })()
};
const unscrambleDecodeModifierVatRate = {
  unsafeDecode: /* #__PURE__ */ (() => {
    const $0 = Unscramble$dGeneric.genericDecodeTaggedSumType(Unscramble$dGeneric.genericDecodeSumSum(Unscramble$dGeneric.genericDecodeSumConstruct1(Unscramble$dGeneric.genericDecodeArgsNoArgume)(IncludedInProductIsSymbol))(Unscramble$dGeneric.genericDecodeSumConstruct(SeparateIsSymbol)({
      unsafeDecodeSingleConstructorArgument: x => Restaumatic$dMenu$dV2$dTypes$dVatRate.unscrambleDecodeVatRate.unsafeDecode(x.contents)
    })))(Unscramble$dGeneric.defaultOptions);
    return x => {
      const $1 = $0(x);
      if ($1.tag === "Inl") { return IncludedInProduct; }
      if ($1.tag === "Inr") { return $ModifierVatRate("Separate", $1._1); }
      $runtime.fail();
    };
  })()
};
const genericModifierItemSection = {to: x => x, from: x => x};
const genericModifierItem = {to: x => x, from: x => x};
const showModifierItem = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor((() => {
      const $0 = Restaumatic$dMenu$dV2$dTypes$dParametric$dParametric.showParametric(Data$dMoney$dRounded.showMoney);
      const $1 = Data$dMap$dInternal.showMap(Restaumatic$dMenu$dV2$dTypes$dAllergen.showAllergen)(Restaumatic$dMenu$dV2$dTypes$dAllergen.showAllergenConcentration);
      return {
        genericShowArgs: v => [
          "{ allergens: " + $1.show(v.allergens) + ", availability: " + Restaumatic$dMenu$dV2$dTypes$dAvailability.showAvailability.show(v.availability) + ", availableWhen: " + showParametric.show(v.availableWhen) + ", defaultSelection: " + Data$dShow.showIntImpl(v.defaultSelection) + (v.irremovable
            ? ", irremovable: true, name: " + showTranslated.show(v.name) + (() => {
                if (v.packagingContainersConfig.tag === "Just") {
                  return ", packagingContainersConfig: (Just " + Restaumatic$dMenu$dV2$dTypes$dPackagingContainer.showPackagingContainersConfig.show(v.packagingContainersConfig._1) + ")" + ", photo: " + showMaybe.show(v.photo) + ", price: " + $0.show(v.price) + " ";
                }
                if (v.packagingContainersConfig.tag === "Nothing") {
                  return ", packagingContainersConfig: Nothing, photo: " + showMaybe.show(v.photo) + ", price: " + $0.show(v.price) + " ";
                }
                $runtime.fail();
              })()
            : ", irremovable: false, name: " + showTranslated.show(v.name) + (() => {
                if (v.packagingContainersConfig.tag === "Just") {
                  return ", packagingContainersConfig: (Just " + Restaumatic$dMenu$dV2$dTypes$dPackagingContainer.showPackagingContainersConfig.show(v.packagingContainersConfig._1) + ")" + ", photo: " + showMaybe.show(v.photo) + ", price: " + $0.show(v.price) + " ";
                }
                if (v.packagingContainersConfig.tag === "Nothing") {
                  return ", packagingContainersConfig: Nothing, photo: " + showMaybe.show(v.photo) + ", price: " + $0.show(v.price) + " ";
                }
                $runtime.fail();
              })()) + "}"
        ]
      };
    })())(ModifierItemIsSymbol);
    return x => $0["genericShow'"](x);
  })()
};
const showModifierItemSection = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor((() => {
      const $0 = Data$dMap$dOrdered.showOMap(Data$dUUID.showUUID)(showModifierItem);
      return {genericShowArgs: v => ["{ items: " + $0.show(v.items) + ", name: " + showMaybe1.show(v.name) + ", photo: " + showMaybe.show(v.photo) + " " + "}"]};
    })())(ModifierItemSectionIsSymbol);
    return x => $0["genericShow'"](x);
  })()
};
const unscrambleDecodeModifierItem = /* #__PURE__ */ (() => (
  {
    unsafeDecode: Unscramble.decodeRecord(Unscramble.decodeRecordCons(allergensIsSymbol)(Unscramble.decodeMap(Restaumatic$dMenu$dV2$dTypes$dAllergen.ufromJSONKeyAllergen)(Restaumatic$dMenu$dV2$dTypes$dAllergen.ordAllergen)(Restaumatic$dMenu$dV2$dTypes$dAllergen.unscrambleDecodeAllergenConcentration))(Unscramble.decodeRecordCons(availabilityIsSymbol)(Restaumatic$dMenu$dV2$dTypes$dAvailability.unscrambleDecodeAvailability)(decodeRecordCons(Unscramble.decodeRecordCons(defaultSelectionIsSymbol)(Unscramble.decodeInt1)(Unscramble.decodeRecordCons(irremovableIsSymbol)(Unscramble.decodeBoolean1)(decodeRecordCons2(Unscramble.decodeRecordCons(packagingContainersConfigIsSymbol)(Unscramble.decodeMaybe(Restaumatic$dMenu$dV2$dTypes$dPackagingContainer.unscrambleDecodePackagingContainersConfig))(decodeRecordCons3(Unscramble.decodeRecordCons(priceIsSymbol)(Restaumatic$dMenu$dV2$dTypes$dParametric$dParametric.udecodeParametric(Data$dMoney$dRounded.udecodeMoney))(Unscramble.decodeRecordNil))))))))).recordInfo(Type$dProxy.Proxy))
  }
))();
const unscrambleDecodeModifierItemSection = /* #__PURE__ */ (() => (
  {
    unsafeDecode: Unscramble.decodeRecord(Unscramble.decodeRecordCons(itemsIsSymbol)(Data$dMap$dOrdered.udecodeMap(unscrambleDecodeModifierItem)(Data$dUUID.udecodeUUID)(Data$dOrd.ordString))(Unscramble.decodeRecordCons(nameIsSymbol)(decodeMaybe)(decodeRecordCons3(Unscramble.decodeRecordNil))).recordInfo(Type$dProxy.Proxy))
  }
))();
const genericModifierDisplayMode = {
  to: x => {
    if (x.tag === "Inl") { return ModifierList; }
    if (x.tag === "Inr") {
      if (x._1.tag === "Inl") { return ModifierCheckboxList; }
      if (x._1.tag === "Inr") {
        if (x._1._1.tag === "Inl") { return ModifierRadioButtonList; }
        if (x._1._1.tag === "Inr") {
          if (x._1._1._1.tag === "Inl") { return ModifierPizzaGrid; }
          if (x._1._1._1.tag === "Inr") { return ModifierHidden; }
          $runtime.fail();
        }
        $runtime.fail();
      }
      $runtime.fail();
    }
    $runtime.fail();
  },
  from: x => {
    if (x.tag === "ModifierList") { return Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments); }
    if (x.tag === "ModifierCheckboxList") { return Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments)); }
    if (x.tag === "ModifierRadioButtonList") {
      return Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments)));
    }
    if (x.tag === "ModifierPizzaGrid") {
      return Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments))));
    }
    if (x.tag === "ModifierHidden") {
      return Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.NoArguments))));
    }
    $runtime.fail();
  }
};
const showModifierDisplayMode = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)(ModifierListIsSymbol);
    const $1 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)(ModifierCheckboxListIsSymbol);
    const $2 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)(ModifierRadioButtonListIsSymbol);
    const $3 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)(ModifierPizzaGridIsSymbol);
    const $4 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)(ModifierHiddenIsSymbol);
    return x => {
      const $5 = genericModifierDisplayMode.from(x);
      if ($5.tag === "Inl") { return $0["genericShow'"]($5._1); }
      if ($5.tag === "Inr") {
        if ($5._1.tag === "Inl") { return $1["genericShow'"]($5._1._1); }
        if ($5._1.tag === "Inr") {
          if ($5._1._1.tag === "Inl") { return $2["genericShow'"]($5._1._1._1); }
          if ($5._1._1.tag === "Inr") {
            if ($5._1._1._1.tag === "Inl") { return $3["genericShow'"]($5._1._1._1._1); }
            if ($5._1._1._1.tag === "Inr") { return $4["genericShow'"]($5._1._1._1._1); }
            $runtime.fail();
          }
          $runtime.fail();
        }
        $runtime.fail();
      }
      $runtime.fail();
    };
  })()
};
const unscrambleDecodeModifierDisplayMode = {
  unsafeDecode: /* #__PURE__ */ Unscramble$dEnum.genericUnsafeDecodeEnum(genericModifierDisplayMode)(/* #__PURE__ */ Unscramble$dEnum.enumConstructorsSum({
    enumConstructors: opts => [Data$dTuple.$Tuple(opts.constructorTagTransform("ModifierList"), Data$dGeneric$dRep.NoArguments)]
  })(/* #__PURE__ */ Unscramble$dEnum.enumConstructorsSum({
    enumConstructors: opts => [Data$dTuple.$Tuple(opts.constructorTagTransform("ModifierCheckboxList"), Data$dGeneric$dRep.NoArguments)]
  })(/* #__PURE__ */ Unscramble$dEnum.enumConstructorsSum({
    enumConstructors: opts => [Data$dTuple.$Tuple(opts.constructorTagTransform("ModifierRadioButtonList"), Data$dGeneric$dRep.NoArguments)]
  })(/* #__PURE__ */ Unscramble$dEnum.enumConstructorsSum({
    enumConstructors: opts => [Data$dTuple.$Tuple(opts.constructorTagTransform("ModifierPizzaGrid"), Data$dGeneric$dRep.NoArguments)]
  })({enumConstructors: opts => [Data$dTuple.$Tuple(opts.constructorTagTransform("ModifierHidden"), Data$dGeneric$dRep.NoArguments)]})))))(Unscramble$dEnum.defaultEnumOptions)
};
const boundedModifierDisplayMod = /* #__PURE__ */ (() => (
  {
    top: genericModifierDisplayMode.to(Data$dGeneric$dRep.$Sum(
      "Inr",
      Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.NoArguments)))
    )),
    bottom: genericModifierDisplayMode.to(Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments)),
    Ord0: () => ordModifierDisplayMode
  }
))();
const enumModifierDisplayMode = {
  succ: /* #__PURE__ */ Data$dEnum$dGeneric.genericSucc(genericModifierDisplayMode)(genericEnumSum2),
  pred: /* #__PURE__ */ Data$dEnum$dGeneric.genericPred(genericModifierDisplayMode)(genericEnumSum2),
  Ord0: () => ordModifierDisplayMode
};
const boundedEnumModifierDispla = /* #__PURE__ */ (() => (
  {
    cardinality: genericBoundedEnumSum2["genericCardinality'"],
    toEnum: Data$dEnum$dGeneric.genericToEnum(genericModifierDisplayMode)(genericBoundedEnumSum2),
    fromEnum: x => genericBoundedEnumSum2["genericFromEnum'"](genericModifierDisplayMode.from(x)),
    Bounded0: () => boundedModifierDisplayMod,
    Enum1: () => enumModifierDisplayMode
  }
))();
const genericModifier = {to: x => x, from: x => x};
const genericDefaultModifierItemsExchangePolicy = {
  to: x => {
    if (x.tag === "Inl") { return NotIncluded; }
    if (x.tag === "Inr") {
      if (x._1.tag === "Inl") { return UnlimitedExchange; }
      if (x._1.tag === "Inr") {
        if (x._1._1.tag === "Inl") { return ExchangeWithClamp; }
        if (x._1._1.tag === "Inr") { return AdditionOnly; }
        $runtime.fail();
      }
      $runtime.fail();
    }
    $runtime.fail();
  },
  from: x => {
    if (x.tag === "NotIncluded") { return Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments); }
    if (x.tag === "UnlimitedExchange") { return Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments)); }
    if (x.tag === "ExchangeWithClamp") { return Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments))); }
    if (x.tag === "AdditionOnly") { return Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.NoArguments))); }
    $runtime.fail();
  }
};
const showDefaultModifierItemsExchangePolicy = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)(NotIncludedIsSymbol);
    const $1 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)(UnlimitedExchangeIsSymbol);
    const $2 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)(ExchangeWithClampIsSymbol);
    const $3 = Data$dShow$dGeneric.genericShowConstructor(Data$dShow$dGeneric.genericShowArgsNoArguments)(AdditionOnlyIsSymbol);
    return x => {
      const $4 = genericDefaultModifierItemsExchangePolicy.from(x);
      if ($4.tag === "Inl") { return $0["genericShow'"]($4._1); }
      if ($4.tag === "Inr") {
        if ($4._1.tag === "Inl") { return $1["genericShow'"]($4._1._1); }
        if ($4._1.tag === "Inr") {
          if ($4._1._1.tag === "Inl") { return $2["genericShow'"]($4._1._1._1); }
          if ($4._1._1.tag === "Inr") { return $3["genericShow'"]($4._1._1._1); }
          $runtime.fail();
        }
        $runtime.fail();
      }
      $runtime.fail();
    };
  })()
};
const showModifier = {
  show: /* #__PURE__ */ (() => {
    const $0 = Data$dShow$dGeneric.genericShowConstructor((() => {
      const $0 = Data$dShow.showArrayImpl(showModifierItemSection.show);
      const $1 = Data$dShow.showArrayImpl(Data$dUUID.toString);
      return {
        genericShowArgs: v => [
          "{ adminNote: " + Data$dShow.showStringImpl(v.adminNote) + ", availableWhen: " + showParametric.show(v.availableWhen) + ", defaultPriceParameters: " + $1(v.defaultPriceParameters) + ", description: " + showMaybe1.show(v.description) + ", displayMode: " + showModifierDisplayMode.show(v.displayMode) + (v.divisible
            ? ", divisible: true, exchangePolicy: " + showDefaultModifierItemsExchangePolicy.show(v.exchangePolicy) + ", maxDuplicatesPerItem: " + showMaybe2.show(v.maxDuplicatesPerItem) + ", maxItems: " + showMaybe2.show(v.maxItems) + ", minItems: " + Data$dShow.showIntImpl(v.minItems) + ", modifierVatRate: " + showModifierVatRate.show(v.modifierVatRate) + ", name: " + showTranslated.show(v.name) + ", photo: " + showMaybe.show(v.photo) + ", sections: " + $0(v.sections) + ", userEditableWhen: " + showParametric.show(v.userEditableWhen) + ", userInputRequiredWhen: " + showParametric.show(v.userInputRequiredWhen) + " "
            : ", divisible: false, exchangePolicy: " + showDefaultModifierItemsExchangePolicy.show(v.exchangePolicy) + ", maxDuplicatesPerItem: " + showMaybe2.show(v.maxDuplicatesPerItem) + ", maxItems: " + showMaybe2.show(v.maxItems) + ", minItems: " + Data$dShow.showIntImpl(v.minItems) + ", modifierVatRate: " + showModifierVatRate.show(v.modifierVatRate) + ", name: " + showTranslated.show(v.name) + ", photo: " + showMaybe.show(v.photo) + ", sections: " + $0(v.sections) + ", userEditableWhen: " + showParametric.show(v.userEditableWhen) + ", userInputRequiredWhen: " + showParametric.show(v.userInputRequiredWhen) + " ") + "}"
        ]
      };
    })())(ModifierIsSymbol);
    return x => $0["genericShow'"](x);
  })()
};
const unscrambleDecodeDefaultModifierItemsExchangePolicy = {
  unsafeDecode: /* #__PURE__ */ Unscramble$dEnum.genericUnsafeDecodeEnum(genericDefaultModifierItemsExchangePolicy)(/* #__PURE__ */ Unscramble$dEnum.enumConstructorsSum({
    enumConstructors: opts => [Data$dTuple.$Tuple(opts.constructorTagTransform("NotIncluded"), Data$dGeneric$dRep.NoArguments)]
  })(/* #__PURE__ */ Unscramble$dEnum.enumConstructorsSum({
    enumConstructors: opts => [Data$dTuple.$Tuple(opts.constructorTagTransform("UnlimitedExchange"), Data$dGeneric$dRep.NoArguments)]
  })(/* #__PURE__ */ Unscramble$dEnum.enumConstructorsSum({
    enumConstructors: opts => [Data$dTuple.$Tuple(opts.constructorTagTransform("ExchangeWithClamp"), Data$dGeneric$dRep.NoArguments)]
  })({enumConstructors: opts => [Data$dTuple.$Tuple(opts.constructorTagTransform("AdditionOnly"), Data$dGeneric$dRep.NoArguments)]}))))(Unscramble$dEnum.defaultEnumOptions)
};
const unscrambleDecodeModifier = /* #__PURE__ */ (() => (
  {
    unsafeDecode: Unscramble.decodeRecord(Unscramble.decodeRecordCons(adminNoteIsSymbol)(Unscramble.decodeString1)(decodeRecordCons(Unscramble.decodeRecordCons(defaultPriceParametersIsSymbol)({
      unsafeDecode: Unscramble.decodeArray(Data$dUUID.udecodeUUID.unsafeDecode)
    })(Unscramble.decodeRecordCons(descriptionIsSymbol)(decodeMaybe)(Unscramble.decodeRecordCons(displayModeIsSymbol)(unscrambleDecodeModifierDisplayMode)(Unscramble.decodeRecordCons(divisibleIsSymbol)(Unscramble.decodeBoolean1)(Unscramble.decodeRecordCons(exchangePolicyIsSymbol)(unscrambleDecodeDefaultModifierItemsExchangePolicy)(Unscramble.decodeRecordCons(maxDuplicatesPerItemIsSymbol)(decodeMaybe1)(Unscramble.decodeRecordCons(maxItemsIsSymbol)(decodeMaybe1)(Unscramble.decodeRecordCons(minItemsIsSymbol)(Unscramble.decodeInt1)(Unscramble.decodeRecordCons(modifierVatRateIsSymbol)(unscrambleDecodeModifierVatRate)(decodeRecordCons2(decodeRecordCons3(Unscramble.decodeRecordCons(sectionsIsSymbol)({
      unsafeDecode: Unscramble.decodeArray(unscrambleDecodeModifierItemSection.unsafeDecode)
    })(Unscramble.decodeRecordCons(userEditableWhenIsSymbol)(udecodeParametric)(Unscramble.decodeRecordCons(userInputRequiredWhenIsSymbol)(udecodeParametric)(Unscramble.decodeRecordNil)))))))))))))))).recordInfo(Type$dProxy.Proxy))
  }
))();
const boundedDefaultModifierIte = /* #__PURE__ */ (() => (
  {
    top: genericDefaultModifierItemsExchangePolicy.to(Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.$Sum("Inr", Data$dGeneric$dRep.NoArguments)))),
    bottom: genericDefaultModifierItemsExchangePolicy.to(Data$dGeneric$dRep.$Sum("Inl", Data$dGeneric$dRep.NoArguments)),
    Ord0: () => ordDefaultModifierItemsEx
  }
))();
const enumDefaultModifierItemsE = {
  succ: /* #__PURE__ */ Data$dEnum$dGeneric.genericSucc(genericDefaultModifierItemsExchangePolicy)(genericEnumSum1),
  pred: /* #__PURE__ */ Data$dEnum$dGeneric.genericPred(genericDefaultModifierItemsExchangePolicy)(genericEnumSum1),
  Ord0: () => ordDefaultModifierItemsEx
};
const boundedEnumDefaultModifie = /* #__PURE__ */ (() => (
  {
    cardinality: genericBoundedEnumSum1["genericCardinality'"],
    toEnum: Data$dEnum$dGeneric.genericToEnum(genericDefaultModifierItemsExchangePolicy)(genericBoundedEnumSum1),
    fromEnum: x => genericBoundedEnumSum1["genericFromEnum'"](genericDefaultModifierItemsExchangePolicy.from(x)),
    Bounded0: () => boundedDefaultModifierIte,
    Enum1: () => enumDefaultModifierItemsE
  }
))();
const encodeModifierVatRate = {
  encode: /* #__PURE__ */ Foreign$dEncoding.defaultEncode(genericModifierVatRate)(/* #__PURE__ */ (() => {
    const $0 = Foreign$dGeneric$dClass.genericEncodeConstructor(IncludedInProductIsSymbol)(Foreign$dGeneric$dClass.genericEncodeArgsNoArguments);
    const $1 = Foreign$dGeneric$dClass.genericEncodeConstructor(SeparateIsSymbol)({
      encodeArgs: opts => v => Data$dList$dTypes.$List(
        "Cons",
        Foreign$dGeneric$dClass.$Arg("PlainArg", Restaumatic$dMenu$dV2$dTypes$dVatRate.encodeVatRate.encode(v)),
        Data$dList$dTypes.Nil
      )
    });
    return {
      encodeOpts: v => v1 => {
        if (v1.tag === "Inl") { return $0.encodeOpts({...v, unwrapSingleConstructors: false})(v1._1); }
        if (v1.tag === "Inr") { return $1.encodeOpts({...v, unwrapSingleConstructors: false})(v1._1); }
        $runtime.fail();
      }
    };
  })())
};
const encodeModifierItem = {
  encode: /* #__PURE__ */ Foreign$dEncoding.defaultEncode(genericModifierItem)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericEncodeConstructor(ModifierItemIsSymbol)(/* #__PURE__ */ (() => {
    const $0 = Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)(priceIsSymbol)((() => {
      const encode1 = Restaumatic$dMenu$dV2$dTypes$dParametric$dParametric.encodeParametric(Data$dMoney$dRounded.encodeMoney)({
        encodeArgs: opts => v => Data$dList$dTypes.$List("Cons", Foreign$dGeneric$dClass.$Arg("PlainArg", Data$dInt.toNumber(v) / 100.0), Data$dList$dTypes.Nil)
      }).encode;
      return {encodeWithOptions: v => encode1};
    })()))(photoIsSymbol)(encodeWithOptionsOther))(packagingContainersConfigIsSymbol)({
      encodeWithOptions: v => v2 => {
        if (v2.tag === "Nothing") { return Foreign$dNullOrUndefined.nullImpl; }
        if (v2.tag === "Just") { return Restaumatic$dMenu$dV2$dTypes$dPackagingContainer.encodePackagingContainersConfig.encode(v2._1); }
        $runtime.fail();
      }
    }))(nameIsSymbol)(encodeWithOptionsOther1))(irremovableIsSymbol)(encodeWithOptionsOther2))(defaultSelectionIsSymbol)(encodeWithOptionsOther3))(availableWhenIsSymbol)(encodeWithOptionsOther4))(availabilityIsSymbol)({
      encodeWithOptions: v => Restaumatic$dMenu$dV2$dTypes$dAvailability.encodeAvailability.encode
    }))(allergensIsSymbol)((() => {
      const encode1 = Data$dMap$dSerialized.encodeMap(Restaumatic$dMenu$dV2$dTypes$dAllergen.asJSONKeyAllergen)(Restaumatic$dMenu$dV2$dTypes$dAllergen.encodeAllergenConcentration)({
        encodeArgs: opts => v => Data$dList$dTypes.$List(
          "Cons",
          Foreign$dGeneric$dClass.$Arg("PlainArg", Restaumatic$dMenu$dV2$dTypes$dAllergen.encodeAllergenConcentration.encode(v)),
          Data$dList$dTypes.Nil
        )
      }).encode;
      return {encodeWithOptions: v => encode1};
    })());
    return {
      encodeArgs: opts => v => Data$dList$dTypes.$List(
        "Cons",
        Foreign$dGeneric$dClass.$Arg("RecArg", $0.encodeRecordWithOptions(Type$dProxy.Proxy)(opts)(v)),
        Data$dList$dTypes.Nil
      )
    };
  })()))
};
const encodeModifierItemSection = {
  encode: /* #__PURE__ */ Foreign$dEncoding.defaultEncode(genericModifierItemSection)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericEncodeConstructor(ModifierItemSectionIsSymbol)(/* #__PURE__ */ (() => {
    const $0 = Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)(photoIsSymbol)(encodeWithOptionsOther))(nameIsSymbol)(encodeWithOptionsOther5))(itemsIsSymbol)((() => {
      const encode1 = Data$dMap$dOrdered.encodeMap({
        encode: Foreign$dEncoding.defaultEncode(Data$dTuple$dT2.genericT2)(Foreign$dGeneric$dClass.genericEncodeConstructor(Data$dTuple$dT2.T2IsSymbol)(Foreign$dGeneric$dClass.genericEncodeArgsProduct({
          encodeArgs: opts => v => Data$dList$dTypes.$List("Cons", Foreign$dGeneric$dClass.$Arg("PlainArg", v), Data$dList$dTypes.Nil)
        })({encodeArgs: opts => v => Data$dList$dTypes.$List("Cons", Foreign$dGeneric$dClass.$Arg("PlainArg", encodeModifierItem.encode(v)), Data$dList$dTypes.Nil)})))
      }).encode;
      return {encodeWithOptions: v => encode1};
    })());
    return {
      encodeArgs: opts => v => Data$dList$dTypes.$List(
        "Cons",
        Foreign$dGeneric$dClass.$Arg("RecArg", $0.encodeRecordWithOptions(Type$dProxy.Proxy)(opts)(v)),
        Data$dList$dTypes.Nil
      )
    };
  })()))
};
const encodeModifierDisplayMode = {
  encode: /* #__PURE__ */ Foreign$dEncoding.defaultEnumEncode(genericModifierDisplayMode)({
    encodeEnum: v => v1 => {
      if (v1.tag === "Inl") { return v.constructorTagTransform("ModifierList"); }
      if (v1.tag === "Inr") {
        if (v1._1.tag === "Inl") { return v.constructorTagTransform("ModifierCheckboxList"); }
        if (v1._1.tag === "Inr") {
          if (v1._1._1.tag === "Inl") { return v.constructorTagTransform("ModifierRadioButtonList"); }
          if (v1._1._1.tag === "Inr") {
            if (v1._1._1._1.tag === "Inl") { return v.constructorTagTransform("ModifierPizzaGrid"); }
            if (v1._1._1._1.tag === "Inr") { return v.constructorTagTransform("ModifierHidden"); }
            $runtime.fail();
          }
          $runtime.fail();
        }
        $runtime.fail();
      }
      $runtime.fail();
    }
  })
};
const encodeDefaultModifierItemsExchangePolicy = {
  encode: /* #__PURE__ */ Foreign$dEncoding.defaultEnumEncode(genericDefaultModifierItemsExchangePolicy)({
    encodeEnum: v => v1 => {
      if (v1.tag === "Inl") { return v.constructorTagTransform("NotIncluded"); }
      if (v1.tag === "Inr") {
        if (v1._1.tag === "Inl") { return v.constructorTagTransform("UnlimitedExchange"); }
        if (v1._1.tag === "Inr") {
          if (v1._1._1.tag === "Inl") { return v.constructorTagTransform("ExchangeWithClamp"); }
          if (v1._1._1.tag === "Inr") { return v.constructorTagTransform("AdditionOnly"); }
          $runtime.fail();
        }
        $runtime.fail();
      }
      $runtime.fail();
    }
  })
};
const encodeModifier = {
  encode: /* #__PURE__ */ Foreign$dEncoding.defaultEncode(genericModifier)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericEncodeConstructor(ModifierIsSymbol)(/* #__PURE__ */ (() => {
    const $0 = Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordCons()(Foreign$dGeneric$dClass.encodeRecordNil)(userInputRequiredWhenIsSymbol)(encodeWithOptionsOther4))(userEditableWhenIsSymbol)(encodeWithOptionsOther4))(sectionsIsSymbol)((() => {
      const encode1 = Data$dFunctor.arrayMap(encodeModifierItemSection.encode);
      return {encodeWithOptions: v => encode1};
    })()))(photoIsSymbol)(encodeWithOptionsOther))(nameIsSymbol)(encodeWithOptionsOther1))(modifierVatRateIsSymbol)({encodeWithOptions: v => encodeModifierVatRate.encode}))(minItemsIsSymbol)(encodeWithOptionsOther3))(maxItemsIsSymbol)(encodeWithOptionsOther6))(maxDuplicatesPerItemIsSymbol)(encodeWithOptionsOther6))(exchangePolicyIsSymbol)({
      encodeWithOptions: v => encodeDefaultModifierItemsExchangePolicy.encode
    }))(divisibleIsSymbol)(encodeWithOptionsOther2))(displayModeIsSymbol)({encodeWithOptions: v => encodeModifierDisplayMode.encode}))(descriptionIsSymbol)(encodeWithOptionsOther5))(defaultPriceParametersIsSymbol)((() => {
      const encode1 = Data$dFunctor.arrayMap(Data$dUUID.encodeUUID.encode);
      return {encodeWithOptions: v => encode1};
    })()))(availableWhenIsSymbol)(encodeWithOptionsOther4))(adminNoteIsSymbol)({encodeWithOptions: v => Unsafe$dCoerce.unsafeCoerce});
    return {
      encodeArgs: opts => v => Data$dList$dTypes.$List(
        "Cons",
        Foreign$dGeneric$dClass.$Arg("RecArg", $0.encodeRecordWithOptions(Type$dProxy.Proxy)(opts)(v)),
        Data$dList$dTypes.Nil
      )
    };
  })()))
};
const decodeModifierVatRate = {
  decode: /* #__PURE__ */ Foreign$dEncoding.defaultDecode(genericModifierVatRate)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeSum(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(IncludedInProductIsSymbol)(Foreign$dGeneric$dClass.genericDecodeArgsNoArguments)(Foreign$dGeneric$dClass.genericCountArgsNoArguments))(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(SeparateIsSymbol)({
    decodeArgs: /* #__PURE__ */ Foreign$dGeneric$dClass.decodeArgsArgument({decodeWithOptions: v => Restaumatic$dMenu$dV2$dTypes$dVatRate.decodeVatRate.decode}),
    decodeSingleRecordArg: Data$dMaybe.Nothing
  })(Foreign$dGeneric$dClass.genericCountArgsArgument)))
};
const decodeModifierItem = {
  decode: /* #__PURE__ */ Foreign$dEncoding.defaultDecode(genericModifierItem)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(ModifierItemIsSymbol)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeArgsRecord(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordNil)(priceIsSymbol)(/* #__PURE__ */ (() => {
    const decode2 = Restaumatic$dMenu$dV2$dTypes$dParametric$dParametric.decodeParametric(Data$dMoney$dRounded.decodeMoney)({
      decodeArgs: Foreign$dGeneric$dClass.decodeArgsArgument({decodeWithOptions: v => Data$dMoney$dRounded.decodeMoney.decode}),
      decodeSingleRecordArg: Data$dMaybe.Nothing
    }).decode;
    return {decodeWithOptions: v => decode2};
  })())())(photoIsSymbol)(decodeWithOptionsOther)())(packagingContainersConfigIsSymbol)({
    decodeWithOptions: v => Foreign$dNullOrUndefined.readNullOrUndefined(Restaumatic$dMenu$dV2$dTypes$dPackagingContainer.decodePackagingContainersConfig.decode)
  })())(nameIsSymbol)(decodeWithOptionsOther1)())(irremovableIsSymbol)(decodeWithOptionsOther2)())(defaultSelectionIsSymbol)(decodeWithOptionsOther3)())(availableWhenIsSymbol)(decodeWithOptionsOther4)())(availabilityIsSymbol)({
    decodeWithOptions: v => Restaumatic$dMenu$dV2$dTypes$dAvailability.decodeAvailability.decode
  })())(allergensIsSymbol)(/* #__PURE__ */ (() => {
    const decode2 = Data$dMap$dSerialized.decodeMap(Restaumatic$dMenu$dV2$dTypes$dAllergen.ordAllergen)(Restaumatic$dMenu$dV2$dTypes$dAllergen.asJSONKeyAllergen)(Restaumatic$dMenu$dV2$dTypes$dAllergen.decodeAllergenConcentration)({
      decodeArgs: Foreign$dGeneric$dClass.decodeArgsArgument({decodeWithOptions: v => Restaumatic$dMenu$dV2$dTypes$dAllergen.decodeAllergenConcentration.decode}),
      decodeSingleRecordArg: Data$dMaybe.Nothing
    }).decode;
    return {decodeWithOptions: v => decode2};
  })())())))(Foreign$dGeneric$dClass.genericCountArgsArgument))
};
const decodeModifierItemSection = {
  decode: /* #__PURE__ */ Foreign$dEncoding.defaultDecode(genericModifierItemSection)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(ModifierItemSectionIsSymbol)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeArgsRecord(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordNil)(photoIsSymbol)(decodeWithOptionsOther)())(nameIsSymbol)(decodeWithOptionsOther5)())(itemsIsSymbol)(/* #__PURE__ */ (() => {
    const decode2 = Data$dMap$dOrdered.decodeMap(Data$dTuple$dT2.decodeT2({
      decodeArgs: Foreign$dGeneric$dClass.decodeArgsArgument({decodeWithOptions: v => Data$dUUID.decodeUUID.decode}),
      decodeSingleRecordArg: Data$dMaybe.Nothing
    })({decodeArgs: Foreign$dGeneric$dClass.decodeArgsArgument({decodeWithOptions: v => decodeModifierItem.decode}), decodeSingleRecordArg: Data$dMaybe.Nothing}))(Data$dOrd.ordString).decode;
    return {decodeWithOptions: v => decode2};
  })())())))(Foreign$dGeneric$dClass.genericCountArgsArgument))
};
const decodeModifierDisplayMode = {
  decode: /* #__PURE__ */ Foreign$dEncoding.defaultEnumDecode(genericModifierDisplayMode)(/* #__PURE__ */ Foreign$dGeneric$dEnumEncoding.sumGenericDecodeEnum(/* #__PURE__ */ Foreign$dGeneric$dEnumEncoding.ctorNoArgsGenericDecodeEnum(ModifierListIsSymbol))(/* #__PURE__ */ Foreign$dGeneric$dEnumEncoding.sumGenericDecodeEnum(/* #__PURE__ */ Foreign$dGeneric$dEnumEncoding.ctorNoArgsGenericDecodeEnum(ModifierCheckboxListIsSymbol))(/* #__PURE__ */ Foreign$dGeneric$dEnumEncoding.sumGenericDecodeEnum(/* #__PURE__ */ Foreign$dGeneric$dEnumEncoding.ctorNoArgsGenericDecodeEnum(ModifierRadioButtonListIsSymbol))(/* #__PURE__ */ Foreign$dGeneric$dEnumEncoding.sumGenericDecodeEnum(/* #__PURE__ */ Foreign$dGeneric$dEnumEncoding.ctorNoArgsGenericDecodeEnum(ModifierPizzaGridIsSymbol))(/* #__PURE__ */ Foreign$dGeneric$dEnumEncoding.ctorNoArgsGenericDecodeEnum(ModifierHiddenIsSymbol))))))
};
const decodeDefaultModifierItemsExchangePolicy = {
  decode: /* #__PURE__ */ Foreign$dEncoding.defaultEnumDecode(genericDefaultModifierItemsExchangePolicy)(/* #__PURE__ */ Foreign$dGeneric$dEnumEncoding.sumGenericDecodeEnum(/* #__PURE__ */ Foreign$dGeneric$dEnumEncoding.ctorNoArgsGenericDecodeEnum(NotIncludedIsSymbol))(/* #__PURE__ */ Foreign$dGeneric$dEnumEncoding.sumGenericDecodeEnum(/* #__PURE__ */ Foreign$dGeneric$dEnumEncoding.ctorNoArgsGenericDecodeEnum(UnlimitedExchangeIsSymbol))(/* #__PURE__ */ Foreign$dGeneric$dEnumEncoding.sumGenericDecodeEnum(/* #__PURE__ */ Foreign$dGeneric$dEnumEncoding.ctorNoArgsGenericDecodeEnum(ExchangeWithClampIsSymbol))(/* #__PURE__ */ Foreign$dGeneric$dEnumEncoding.ctorNoArgsGenericDecodeEnum(AdditionOnlyIsSymbol)))))
};
const decodeModifier = {
  decode: /* #__PURE__ */ Foreign$dEncoding.defaultDecode(genericModifier)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeConstructor(ModifierIsSymbol)(/* #__PURE__ */ Foreign$dGeneric$dClass.genericDecodeArgsRecord(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeWithOptionsRecord()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(/* #__PURE__ */ Foreign$dGeneric$dClass.decodeRecordCons()(Foreign$dGeneric$dClass.decodeRecordNil)(userInputRequiredWhenIsSymbol)(decodeWithOptionsOther4)())(userEditableWhenIsSymbol)(decodeWithOptionsOther4)())(sectionsIsSymbol)(/* #__PURE__ */ (() => {
    const decode2 = Foreign$dGeneric$dClass.arrayDecode(decodeModifierItemSection).decode;
    return {decodeWithOptions: v => decode2};
  })())())(photoIsSymbol)(decodeWithOptionsOther)())(nameIsSymbol)(decodeWithOptionsOther1)())(modifierVatRateIsSymbol)({decodeWithOptions: v => decodeModifierVatRate.decode})())(minItemsIsSymbol)(decodeWithOptionsOther3)())(maxItemsIsSymbol)(decodeWithOptionsOther6)())(maxDuplicatesPerItemIsSymbol)(decodeWithOptionsOther6)())(exchangePolicyIsSymbol)({
    decodeWithOptions: v => decodeDefaultModifierItemsExchangePolicy.decode
  })())(divisibleIsSymbol)(decodeWithOptionsOther2)())(displayModeIsSymbol)({decodeWithOptions: v => decodeModifierDisplayMode.decode})())(descriptionIsSymbol)(decodeWithOptionsOther5)())(defaultPriceParametersIsSymbol)(/* #__PURE__ */ (() => {
    const decode2 = Foreign$dGeneric$dClass.arrayDecode(Data$dUUID.decodeUUID).decode;
    return {decodeWithOptions: v => decode2};
  })())())(availableWhenIsSymbol)(decodeWithOptionsOther4)())(adminNoteIsSymbol)({decodeWithOptions: v => Foreign$dGeneric$dClass.readString})())))(Foreign$dGeneric$dClass.genericCountArgsArgument))
};
export {
  $DefaultModifierItemsExchangePolicy,
  $ModifierDisplayMode,
  $ModifierVatRate,
  AdditionOnly,
  AdditionOnlyIsSymbol,
  ExchangeWithClamp,
  ExchangeWithClampIsSymbol,
  IncludedInProduct,
  IncludedInProductIsSymbol,
  Modifier,
  ModifierCheckboxList,
  ModifierCheckboxListIsSymbol,
  ModifierHidden,
  ModifierHiddenIsSymbol,
  ModifierIsSymbol,
  ModifierItem,
  ModifierItemIsSymbol,
  ModifierItemSection,
  ModifierItemSectionIsSymbol,
  ModifierList,
  ModifierListIsSymbol,
  ModifierPizzaGrid,
  ModifierPizzaGridIsSymbol,
  ModifierRadioButtonList,
  ModifierRadioButtonListIsSymbol,
  NotIncluded,
  NotIncludedIsSymbol,
  Separate,
  SeparateIsSymbol,
  UnlimitedExchange,
  UnlimitedExchangeIsSymbol,
  adminNoteIsSymbol,
  allergensIsSymbol,
  availabilityIsSymbol,
  availableWhenIsSymbol,
  boundedDefaultModifierIte,
  boundedEnumDefaultModifie,
  boundedEnumModifierDispla,
  boundedModifierDisplayMod,
  decodeDefaultModifierItemsExchangePolicy,
  decodeMaybe,
  decodeMaybe1,
  decodeModifier,
  decodeModifierDisplayMode,
  decodeModifierItem,
  decodeModifierItemSection,
  decodeModifierVatRate,
  decodeRecordCons,
  decodeRecordCons2,
  decodeRecordCons3,
  decodeTranslated,
  decodeWithOptionsOther,
  decodeWithOptionsOther1,
  decodeWithOptionsOther2,
  decodeWithOptionsOther3,
  decodeWithOptionsOther4,
  decodeWithOptionsOther5,
  decodeWithOptionsOther6,
  defaultPriceParametersIsSymbol,
  defaultSelectionIsSymbol,
  descriptionIsSymbol,
  displayModeIsSymbol,
  divisibleIsSymbol,
  encodeDefaultModifierItemsExchangePolicy,
  encodeModifier,
  encodeModifierDisplayMode,
  encodeModifierItem,
  encodeModifierItemSection,
  encodeModifierVatRate,
  encodeTranslated,
  encodeWithOptionsOther,
  encodeWithOptionsOther1,
  encodeWithOptionsOther2,
  encodeWithOptionsOther3,
  encodeWithOptionsOther4,
  encodeWithOptionsOther5,
  encodeWithOptionsOther6,
  enumDefaultModifierItemsE,
  enumModifierDisplayMode,
  eq1,
  eq10,
  eq12,
  eq15,
  eq16,
  eq3,
  eq7,
  eq9,
  eqDefaultModifierItemsExc,
  eqModifier,
  eqModifierDisplayMode,
  eqModifierItem,
  eqModifierItemSection,
  eqModifierVatRate,
  eqTranslated,
  exchangePolicyIsSymbol,
  genericBottomConstructor,
  genericBottomSum,
  genericBoundedEnumConstructor,
  genericBoundedEnumSum,
  genericBoundedEnumSum1,
  genericBoundedEnumSum2,
  genericDefaultModifierItemsExchangePolicy,
  genericEnumConstructor,
  genericEnumSum,
  genericEnumSum1,
  genericEnumSum2,
  genericModifier,
  genericModifierDisplayMode,
  genericModifierItem,
  genericModifierItemSection,
  genericModifierVatRate,
  genericTopConstructor,
  hasFieldModifier,
  hasFieldModifierItem,
  hasFieldModifierItemSecti,
  irremovableIsSymbol,
  itemsIsSymbol,
  maxDuplicatesPerItemIsSymbol,
  maxItemsIsSymbol,
  minItemsIsSymbol,
  modifierVatRateIsSymbol,
  nameIsSymbol,
  newtypeModifierItemSectio,
  newtypeModifierItem_,
  newtypeModifier_,
  ordDefaultModifierItemsEx,
  ordModifierDisplayMode,
  ordModifierVatRate,
  packagingContainersConfigIsSymbol,
  photoIsSymbol,
  priceIsSymbol,
  sectionsIsSymbol,
  showDefaultModifierItemsExchangePolicy,
  showMaybe,
  showMaybe1,
  showMaybe2,
  showModifier,
  showModifierDisplayMode,
  showModifierItem,
  showModifierItemSection,
  showModifierVatRate,
  showParametric,
  showTranslated,
  udecodeParametric,
  udecodeTranslated,
  unscrambleDecodeDefaultModifierItemsExchangePolicy,
  unscrambleDecodeModifier,
  unscrambleDecodeModifierDisplayMode,
  unscrambleDecodeModifierItem,
  unscrambleDecodeModifierItemSection,
  unscrambleDecodeModifierVatRate,
  userEditableWhenIsSymbol,
  userInputRequiredWhenIsSymbol
};
